import { Link } from "react-router-dom";
import { FeatherIcons, H5, Image, LI, P } from "../../../../AbstractElements";
import { CheckAll, Href } from "../../../../utils/Constant";
import { messagesHeaderData } from "../../../../Data/Layout/HeaderData";
import { dynamicImage } from "../../../../Service";

const MessagesBox = () => {
  return (
    <>
      {messagesHeaderData.map((item, i) => (
        <LI key={i}>
          <div className={`d-flex align-items-start`}>
            <div className={`message-img bg-light-${item.borderColor}`}>
              <Image src={dynamicImage(`user/${item.image}`)} alt="users" />
            </div>
            <div className="flex-grow-1">
              <H5 className="mb-1">
                <Link to={Href}>{item.title}</Link>
                <P>{item.time}</P>
              </H5>
            </div>
            <div className="notification-right">
              <FeatherIcons iconName="X" />
            </div>
          </div>
        </LI>
      ))}
      <LI>
        <Link className="f-w-700" to={`${process.env.PUBLIC_URL}/email/letterbox`}>{CheckAll}</Link>
      </LI>
    </>
  );
};

export default MessagesBox;
